import { render, staticRenderFns } from "./Canada.vue?vue&type=template&id=6dfbf117&"
import script from "./Canada.vue?vue&type=script&lang=js&"
export * from "./Canada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dfbf117')) {
      api.createRecord('6dfbf117', component.options)
    } else {
      api.reload('6dfbf117', component.options)
    }
    module.hot.accept("./Canada.vue?vue&type=template&id=6dfbf117&", function () {
      api.rerender('6dfbf117', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Canada.vue"
export default component.exports